import { api, ServiceName } from './api';
import { logger } from '../logger/logger';
import { FeatureDefinition } from '@growthbook/growthbook';
import {
  LOGGER_FEATURE,
  LOGGER_SERVICE,
} from '../../constants/logger/logger-tags';

export interface FeatureFlagDataResponse {
  status: number;
  features: Record<string, FeatureDefinition>;
  dateUpdated: string;
  country: string | null;
}

class ApiFeatureFlag {
  public async loadFeatures(): Promise<FeatureFlagDataResponse | undefined> {
    try {
      const response = await api.httpGet(ServiceName.FeatureFlag, '/features');
      return response as FeatureFlagDataResponse;
    } catch (error) {
      // This is a warning, not an error - the app continues with defaults
      logger.warn('Failed to load feature flags, using defaults', {
        tags: {
          feature: LOGGER_FEATURE.FEATURE_FLAGS,
          service: LOGGER_SERVICE.FEATURE_FLAG_API,
        },
        extra: {
          errorMessage: error instanceof Error ? error.message : String(error),
        },
      });
      return undefined;
    }
  }
}

export const apiFeatureFlag = new ApiFeatureFlag();
